import type { ResourceNode, ResourceNodeClass } from '../ProcessTemplateV2/types';
import { BINDABLE_CLASSES } from './resourceNodeConstants';

export type SystemTypeFilter = 'ALL' | 'SUS' | 'SS' | 'VIRTUAL';

export interface ResourceNodeFilters {
  search: string;
  nodeClass: ResourceNodeClass | 'ALL';
  systemType: SystemTypeFilter;
  issuesOnly: boolean;
}

export const resourceNodeHasIssue = (node: ResourceNode): boolean => {
  if (!node.isActive) return true;
  if (!BINDABLE_CLASSES.has(node.nodeClass)) return false;
  return !node.boundResourceId
    || node.boundResourceStatus !== 'ACTIVE'
    || !node.boundResourceIsSchedulable;
};

export const filterResourceNodeTree = (
  nodes: ResourceNode[],
  filters: ResourceNodeFilters,
): ResourceNode[] => {
  const query = filters.search.trim().toLowerCase();

  return nodes.flatMap((node) => {
    const filteredChildren = filterResourceNodeTree(node.children, filters);
    const matchesSearch = !query || [
      node.nodeName,
      node.nodeCode,
      node.boundResourceCode ?? '',
      node.boundResourceName ?? '',
    ].join(' ').toLowerCase().includes(query);
    const matchesNodeClass = filters.nodeClass === 'ALL' || node.nodeClass === filters.nodeClass;
    const matchesSystemType = filters.systemType === 'ALL'
      || node.equipmentSystemType === filters.systemType;
    const matchesIssue = !filters.issuesOnly || resourceNodeHasIssue(node);
    const matchesSelf = matchesSearch && matchesNodeClass && matchesSystemType && matchesIssue;

    if (matchesSelf) {
      return [{ ...node, children: node.children }];
    }
    if (filteredChildren.length) {
      return [{ ...node, children: filteredChildren }];
    }
    return [];
  });
};
